var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpHeroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 145,
    viewBox: "0 0 139 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Power Play"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.729 80.7676H0.0078125V121.336C0.0078125 133.945 10.2412 144.178 22.8502 144.178C35.4591 144.178 45.6925 133.945 45.6925 121.336V80.7676H45.729Z",
    fill: "#F9B7AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.2883 22.8065L45.0346 14.9487L41.1606 12.6462L32.2429 7.67572L27.309 4.8981L22.3019 2.01082C17.6604 -0.693712 12.1051 -0.693712 7.42701 2.01082C2.78544 4.71536 0.0078125 9.50311 0.0078125 14.8756V30.2257V74.7043V80.1499V123.422C0.0078125 111.727 19.8898 97.4736 30.9272 90.4564L36.2632 87.3864L49.7128 79.6017L83.0443 60.3776C87.6859 57.6731 90.4635 52.8853 90.4635 47.5128C90.4635 47.5128 91.2676 40.6053 83.9946 36.3657L59.2883 22.8065Z",
    fill: "#EF4223"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.4991 117.799C70.8412 118.969 69.8544 119.919 68.5022 120.613C67.1865 121.308 65.5418 121.673 63.6048 121.673H60.352V129.677H53.7734V105.994H63.6048C65.5053 105.994 67.1134 106.323 68.4656 107.017C69.7814 107.675 70.8047 108.626 71.4626 109.795C72.1204 110.965 72.4859 112.353 72.4859 113.888C72.4859 115.314 72.157 116.593 71.4991 117.799ZM65.7976 113.888C65.7976 112.171 64.884 111.294 63.02 111.294H60.3886V116.41H63.02C64.8474 116.41 65.7976 115.57 65.7976 113.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.7348 124.598H89.0809V129.642H75.1562V105.995H81.7348V124.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M108.679 125.767H100.273L98.9935 129.642H92.0859L100.711 105.995H108.313L116.902 129.642H109.958L108.679 125.767ZM107.034 120.76L104.476 113.122L101.954 120.76H107.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M138.471 105.995L130.138 122.149V129.678H123.559V122.149L115.227 105.995H122.755L126.922 115.132L131.088 105.995H138.471Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M60.1641 83.2172C61.9184 83.2172 63.3438 83.802 64.4768 84.935C65.6097 86.1045 66.158 87.5664 66.158 89.3572C66.158 91.1481 65.6097 92.61 64.4768 93.743C63.3438 94.9125 61.9184 95.4607 60.1641 95.4607H56.1073V100.979H53.8048V83.1807H60.1641V83.2172ZM60.0545 93.4506C61.1509 93.4506 62.0646 93.0851 62.759 92.3176C63.4534 91.5501 63.8189 90.5999 63.8189 89.4303C63.8189 88.2608 63.4534 87.274 62.759 86.5065C62.0646 85.739 61.1509 85.3735 60.0545 85.3735H56.1073V93.4871H60.0545V93.4506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M83.5233 98.7512C81.8421 100.542 79.6127 101.456 76.835 101.456C74.0574 101.456 71.828 100.542 70.1468 98.7512C68.4656 96.9604 67.625 94.731 67.625 92.1361C67.625 89.5412 68.4656 87.3118 70.1468 85.5209C71.828 83.7301 74.0574 82.8164 76.835 82.8164C79.6127 82.8164 81.8421 83.7301 83.5233 85.5209C85.2045 87.3118 86.0451 89.5412 86.0451 92.1361C86.0451 94.7675 85.2045 96.9604 83.5233 98.7512ZM71.9376 97.2893C73.1437 98.6781 74.7884 99.3725 76.8716 99.3725C78.9548 99.3725 80.5995 98.6781 81.8055 97.2893C83.0116 95.9005 83.6329 94.1828 83.5964 92.1361C83.5964 90.0894 83.0116 88.3717 81.8055 86.9828C80.5995 85.594 78.9548 84.8996 76.8716 84.8996C74.7884 84.8996 73.1437 85.594 71.9376 86.9828C70.7316 88.3717 70.1102 90.0894 70.1102 92.1361C70.1102 94.1828 70.695 95.9005 71.9376 97.2893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M92.2466 101.054L86.1797 83.2549H88.6284L93.1969 97.2527L97.4364 83.2549H99.1907L103.43 97.2527L107.999 83.2549H110.447L104.344 101.054H102.626L98.3135 87.2751L94.0009 101.054H92.2466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M112.508 101.054V83.2549H122.632V85.3381H114.81V91.1492H122.632V93.2324H114.81V98.9704H122.632V101.054H112.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M138.751 89.3948C138.751 90.7836 138.386 91.9897 137.692 93.0496C136.997 94.0729 136.047 94.8038 134.877 95.2059L138.496 101.054H135.864L132.429 95.5348H128.701V101.054H126.398V83.2548H132.794C134.548 83.2548 135.974 83.8395 137.107 84.9725C138.167 86.1055 138.751 87.6039 138.751 89.3948ZM128.701 85.338V93.4516H132.648C133.744 93.4516 134.658 93.0861 135.353 92.3186C136.047 91.5511 136.412 90.6009 136.412 89.4313C136.412 88.2618 136.047 87.275 135.353 86.5075C134.658 85.74 133.744 85.3745 132.648 85.3745H128.701V85.338Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpHeroLogo);
export default __webpack_public_path__ + "static/media/pp-hero-logo.afba43d7b40e8582300a34cacd1f003c.svg";
export { ForwardRef as ReactComponent };